import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import instance from "services/axiosServices";

interface Props extends QueryGlobalInterface {
  isSul?: boolean;
  idsBandeiras: string[];
}

export function useListarUsuariosCorretoresFifty(props: Props) {
  const fetchData = async () => {
    const baseUrl =
      "identity/usuario/v1/listar-usuarios-por-equipe-corretor-fifty";
    const params = new URLSearchParams();
    if (props.isSul) {
      params.append("ativos", "true");
    }
    if (
      props.idsBandeiras &&
      Array.isArray(props.idsBandeiras) &&
      props.idsBandeiras.length > 0
    ) {
      props.idsBandeiras.forEach((idsBandeiras: string) => {
        if (idsBandeiras) {
          params.append("idsBandeiras", idsBandeiras);
        }
      });
    }
    const queryString = params.toString();
    const LISTAR_USUARIOS_CORRETORES = queryString
      ? `${baseUrl}?${queryString}`
      : baseUrl;
    const response = await instance.get(LISTAR_USUARIOS_CORRETORES);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    // onError: (error: any) => {
    //   toast.error(`Erro ao buscar oportunidades. Tente novamente.`);
    //   console.error(error);
    // },
  });
  return query;
}
